import React from "react";
import {
  motion,
  useMotionValue,
  useTransform,
  animate,
  useInView,
} from "framer-motion";
import "../Styles/Why_Us.css";

import BulbImage from "../../Asserts/Bulb.png";
import BackgroundImage from "../../Asserts/Solar_panallel.png";

// CountUp Component
const CountUp = ({ to, startWhenVisible }) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));

  React.useEffect(() => {
    if (startWhenVisible) {
      const controls = animate(count, to, {
        duration: 3,
        ease: "easeOut",
      });
      return controls.stop;
    }
  }, [to, startWhenVisible, count]);

  return <motion.span>{rounded}</motion.span>;
};

// REUSABLE COMPONENT ✔ HOOKS ALLOWED HERE
const StatBox = ({ number, label }) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <motion.div
      ref={ref}
      className="stat-box"
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
      }}
    >
      <div className="stat-number">
        <CountUp to={number} startWhenVisible={isInView} />
      </div>
      <div className="stat-label">{label}</div>
    </motion.div>
  );
};

const statsData = [
  { number: 50, label: "Years" },
  { number: 500, label: "Projects" },
  { number: 200, label: "Happy Clients" },
];

const Why_Us = () => {
  return (
    <div className="stahlform-container">
      {/* Bulb image */}
      <div className="bulb-wrapper">
        <img src={BulbImage} alt="Bulb" className="bulb-image" />
      </div>

      {/* Main Content */}
      <div
        className="main-content-box"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className="overlay"></div>

        <h2 className="section-heading">Years of Industry Experience</h2>

        {/* Stats Row */}
        <div className="stats-row">
          {statsData.map((stat, index) => (
            <StatBox
              key={index}
              number={stat.number}
              label={stat.label}
            />
          ))}
        </div>

        {/* Description */}
        <div className="description-content">
          <p className="description-paragraph">
            Our team has consistently delivered outstanding results in every
            project we undertake. The numbers above reflect our dedication,
            expertise, and commitment to excellence in the industry.
          </p>
          <p className="description-paragraph">
            We pride ourselves on creating innovative solutions that exceed
            expectations, build long-lasting relationships with clients, and
            drive industry standards forward.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Why_Us;
